import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../util/axios";
import { Provider, ProviderStatusResponse } from "../types/provider";
import { useTranslation } from "react-i18next";
import { notification } from "antd";

export const useGetProviders = () =>
  useQuery<Provider[]>({
    queryKey: ["providerList"],
    queryFn: () => axiosInstance.get("/provider/list").then((w) => w.data),
    initialData: [],
  });

export const useVerifyProviders = (options: { enabled: boolean }) =>
  useQuery<ProviderStatusResponse[]>({
    queryKey: ["providerVerify"],
    queryFn: () => axiosInstance.get("/provider/verify").then((w) => w.data),
    initialData: [],
    enabled: options.enabled,
  });

export const useDeleteProvider = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (providerId: string) =>
      axiosInstance.delete(`/provider/${providerId}`),
    onSuccess: () => {
      notification.success({
        message: t("toast.provider-removed"),
        description: t("toast.provider-removed-description"),
      });
      return queryClient.invalidateQueries({ queryKey: ["providerList"] });
    },
    onError: () => {
      notification.error({
        message: t("toast.failed-to-remove-provider"),
        description: t("toast.please-check-your-credentials"),
      });
    },
  });
};
